import { Typography, TypographyProps } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

const NoProgramPlaceholder = (props: TypographyProps) => {
    const { t: translate } = useTranslation()
    return (
        <Typography
            textAlign="left"
            component="h6"
            className="no-epg-data-info"
            mt="8px"
            variant="text3"
            lineHeight="14px"
            color="white"
            {...props}>
            {translate('missingEpgData')}
        </Typography>
    )
}

export default NoProgramPlaceholder
